<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Partner Invoice List
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Paid_at
                <b-button size="sm" variant="info" @click="set_sd('', 'paid_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'paid_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'paid_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'paid_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'paid_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'paid_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.paid_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.paid_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                <b-button inline variant="warning" @click="so.opt['paid_at_ed'] = ''; so.opt['paid_at_sd'] = ''">Clear</b-button>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Refund_at
                <b-button size="sm" variant="info" @click="set_sd('', 'refund_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'refund_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'refund_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'refund_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'refund_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'refund_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.refund_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.refund_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                <b-button inline variant="warning" @click="so.opt['paid_at_ed'] = ''; so.opt['paid_at_sd'] = ''">Clear</b-button>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <label for="opt_invoice_id">Invoice ID</label>
            <b-input v-model="so.opt['invoice_id']" @keyup.enter="refresh"></b-input>
          </b-col>
          <b-col md="6">
            <label for="opt_description">Description</label>
            <b-input v-model="so.opt['description']" @keyup.enter="refresh"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <label for="ph_search_group">Group Name</label>
            <b-button id="ph_search_group" :variant="group_name ? 'primary' : 'success'" @click="chainGroup = true">Select Group</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <label for="ph_search_partner">Partner Name</label>
            <b-button id="ph_search_partner" :variant="partner_name ? 'primary' : 'success'" @click="chainPartner = true">Select Partner</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="partner_name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3">
            <label for="ph_search_opt_type">Payment Failed</label>
            <b-form-group>
              <c-switch color="info" label size="sm" v-model="so.opt['is_failed']" @change="change_failed" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <label for="ph_search_opt_type">Payment Done</label>
            <b-form-group>
              <c-switch color="info" label size="sm" v-model="so.opt['is_paid']" @change="change_done" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <label for="ph_search_opt_type">Refunded</label>
            <b-form-group>
              <c-switch color="info" label size="sm" v-model="so.opt['is_refunded']" @change="change_refunded" />
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="4">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" @change="refresh" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <hr>
      <b-row>
        <b-col sm="2" v-if="view_detail !== false">
          <b-badge variant="primary">
            TOTAL : {{(model.not_paid + model.total_paid) | dollar}}
          </b-badge>
          <br>
          <b-badge variant="success">
            Payment : {{model.total_paid | dollar}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Unpaid : {{model.not_paid | dollar}}
          </b-badge>
        </b-col>

        <b-col :sm="view_detail !== false ? 10 : 12" class="md-10">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <!-- <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='service.service_name';so.skt='Service'">Service</b-dropdown-item>
              </b-dropdown> -->
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
            <div>
              <b-button v-if="enable_new !== false && !partner_id" size="sm" variant="success" @click="modal_new = true"> Invoice & Recipient </b-button>
            </div>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-tooltip class="w-100" block target="tooltip-target-1" triggers="hover">
        (?) : has some paid history
        <br>
        <!-- Target : who can get received of mail
        <br>
        Title : title of mail -->
      </b-tooltip>
      <b-table id="tooltip-target-1" triggers="hover" striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="partner" slot-scope="row"> {{row.item.partner ? row.item.partner.username : '-'}}</template>

        <!-- <template slot="service" slot-scope="row">
          <b-badge v-if="row.item.service.service_name" :variant="row.item.service.service_name == 'Basic' ? 'primary' : 'success'">{{row.item.service.service_name }}</b-badge>
          <span v-else>-</span>
        </template> -->
        <template slot="status" slot-scope="row">
            <b-badge v-if="row.item.is_paid" variant="success">Payment</b-badge>
            <b-badge v-if="row.item.is_refunded" variant="warning">Refunded</b-badge>
            <b-badge v-if="row.item.is_failed" variant="danger">Failed Pay</b-badge>
            <b-badge v-if="!row.item.is_paid && !row.item.is_refunded && !row.item.is_failed" variant="light">-</b-badge>

        </template>
        <template slot="price" slot-scope="row">
          <span v-if="row.item.is_paid"> {{row.item.total_paid | dollar}}</span>
          <span v-else>{{row.item.total_price - row.item.total_partner_price | dollar}}</span>
          <b-badge style="cursor:pointer" @click="modal_history(row.item.history)" v-if="row.item.is_paid == false && row.item.total_paid" variant="primary">?</b-badge>
        </template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn>
          <b-btn :disabled="!row.item.paypal_id" @click="bill(row.item.paypal_id)" size="sm" variant="outline-primary">PayPal</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
        <b-col>
          <b-button size="sm" variant="dark" @click="confirm_ticket_invoice = true;" v-if="model.id"> Ticket Invoice </b-button>
        </b-col>
      </b-row>
    </b-card>
    <!-- start modal -->
    <b-modal title="Find then Group and Select" size="xl"  header-bg-variant="info" v-model="chainGroup" @ok="chainGroup = false" ok-only cancel-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
    <!-- start modal -->
    <b-modal title="Find then Partner and Select" size="xl"  header-bg-variant="info" v-model="chainPartner" @ok="chainPartner = false" ok-only cancel-variant="info">
      <partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setPartner"></partner-List>
    </b-modal>
    <!-- start modal -->
    <b-modal title="Find then Partner and Select" size="xl"  header-bg-variant="info" v-model="confirm_payment_history" @ok="confirm_payment_history = false" ok-only cancel-variant="primary">
      <!-- {"purchased_at":"2020-07-30T05:20:58.965844Z","action":"partner payment","pg_name":"f1","pg":"credit","price":10.0} -->
      <ul>
        <!-- TODO : 테이블로 예쁘게 해야 함 -->
        <li v-for="item in payment_history" v-bind:key="item.id" v-bind:class="{ strong: item.hp > 300 }">
          <p v-if="item && item.payer">
            <!-- paypal -->
            <!-- {{item}} -->
            [Purchased Date:{{item.purchase_units[0].payments.captures[0].create_time | datetime}}]
            [Company:{{item.payer.email_address}}]
            [Action:{{item.purchase_units[0].description}}]
            [Method:{{item.pg}}]
            [price:{{item.purchase_units[0].amount.value}}]
            [Currenty:{{item.purchase_units[0].amount.currency_code}}]
            [Country:{{item.payer.address.country_code}}]
          </p>
          <p v-else>
            <!-- boot_pay or credit -->
            [Purchased Date:{{item.purchased_at | datetime}}]
            [Company:{{item.pg_name}}]
            [Action:{{item.action}}]
            [Method:{{item.pg}}]
            [price:{{item.price}}]
            [Currenty:{{'KRW'}}]
            [Country:{{'KR'}}]
            <!-- country_code, currency_code -->
          </p>
        </li>
      </ul>
    </b-modal>
    <!-- new -->
    <b-modal title="Created invoice & recipient" size="xl"  header-bg-variant="info" v-model="modal_new" @ok="new_invoice()" ok-only cancel-variant="primary" hide-footer>
      <b-row>
        <b-col md="2">
          <label>Invoice ID</label>
        </b-col>
        <b-col md="3">
          <b-input v-model="invoice.invoice_id" disabled placeholder="system auto generated" @keyup.enter="refresh"></b-input>
        </b-col>
        <b-col md="2">
          Partner Name
        </b-col>
        <b-col md="3">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="true" v-model="partner_name">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group>
            <b-button block id="ph_search_partner" :variant="partner_name ? 'primary' : 'success'" @click="chainPartner = true">Select Partner</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2">
          Started_at
        </b-col>
        <b-col>
          <date-picker v-model="invoice.start_at" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
          <!-- <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="invoice.month"> </vue-monthly-picker> -->
        </b-col>
        <b-col md="2">
          Ended_at
        </b-col>
        <b-col>
          <date-picker v-model="invoice.end_at" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
          <!-- <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="invoice.month"> </vue-monthly-picker> -->
        </b-col>
        <b-col md="2">
          Paid_at
        </b-col>
        <b-col>
          <date-picker v-model="invoice.paid_at" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
          <!-- <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="invoice.month"> </vue-monthly-picker> -->
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2">
          <label for="ph_search_partner">Paid Amount</label>
        </b-col>
        <b-col md="3">
          <b-input-group prepend="$">
            <b-form-input @keydown.enter="refresh" type="number" :disabled="false" v-model="invoice.amount">
            </b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="2">
          <label for="ph_search_opt_type">* Include VAT</label>
        </b-col>
        <b-col md="1">
          <b-form-group>
            <c-switch color="info" label size="sm" v-model="invoice.is_tax" @change="change_failed" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <label for="ph_search_opt_type">* TAX Amount(%)</label>
        </b-col>
        <b-col md="2">
          <b-input-group prepend="$">
            <b-form-input @keydown.enter="refresh" type="number" :disabled="!invoice.is_tax" v-model="invoice.tax"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-row class="text-center">
        <b-col md="12">
          Usage Service Info
        </b-col>
      </b-row>
      <hr>
      <b-row class="m-2 text-center">
        <b-col md="4">
          Service Name
        </b-col>
        <b-col>
          Partner Price
        </b-col>
        <b-col>
          Usage
        </b-col>
        <b-col>
          Amount
        </b-col>
        <b-col>
        </b-col>
      </b-row>
      <hr>
      <b-row v-for="(service, index) in service_list" :key="index" class="m-4">
        <b-col md="4">
          <v-select :readonly="true" label="service_name" v-model="service.service_name" :options="partner_service"></v-select>
        </b-col>
        <b-col>
          <b-form-input type="number" v-model="service.partner_price"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input type="number" v-model="service.usage"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input type="number" v-model="service.amount"></b-form-input>
        </b-col>
        <b-col>
          <b-button size="sm" variant="warning" @click="remove_service(index)" block> Remove </b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row class="m-4">
        <b-col md="4">
          <v-select :readonly="false" :disabled="!invoice.partner_id" @input="(x) => this.service = Object.assign({}, this.service, x)" v-if="!model.service_name" label="service_name" v-model="model.service" :options="partner_service"></v-select>
        </b-col>
        <b-col>
          <b-form-input :disabled="!invoice.partner_id" @keydown.enter="refresh" type="number" v-model="service.partner_price" placeholder="select service first"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input :disabled="!invoice.partner_id" @keydown.enter="refresh" type="number" v-model="service.usage" @update="service.amount = Number((Number(service.usage) * Number(service.partner_price)).toFixed(2))"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input :disabled="!invoice.partner_id" @keydown.enter="refresh" type="number" v-model="service.amount"></b-form-input>
        </b-col>
        <b-col>
          <b-button size="sm" variant="success" @click="set_service()" block :disabled="!invoice.partner_id"> Add </b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="12">
          <label for="opt_description">Description(Only admin showing)</label>
          <b-textarea v-model="invoice.description" @keyup.enter="refresh"></b-textarea>
        </b-col>
      </b-row>
      <hr>
      <!-- {{invoice}} -->
      <hr>
      <!-- {{service_list}} -->
      <hr>
      <b-form-group class="float-right">
        <b-button size="sm" variant="success" @click="new_invoice"> Save </b-button>
        <!-- <b-button size="sm" variant="warning" @click="reset"> Reset </b-button> -->
        <!-- <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button> -->
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
import { Api } from '@/service';
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import partnerList from '../../Management/partner/Partner.List'
import groupList from '../../Management/group/Group.List'
import { Switch as cSwitch } from '@coreui/vue';
import VueMonthlyPicker from 'vue-monthly-picker'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  components: { DatePicker, vSelect, partnerList, groupList, cSwitch, VueMonthlyPicker },
  props : ["auto_refresh", "enable_new", "view_detail", 'partner_id'],
  name : "InvoiceList",
  data: () => ({
    service : {},
    service_list : [],
    partner_service : [],
    modal_new : false,
    confirm_payment_history : false,
    payment_history : '',
    loading : false,
    group_name : '',
    chainGroup : false,
    partner_name : '',
    chainPartner : false,
    custom,
    codes,
    datepicker,
    so : default_opt(),
    model : { total : 0, total_paid : 0, not_paid : 0 },
    invoice : { amount : 0 },
    sync : { interval : 15, stop : false, th : undefined },
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = [
        { key: 'id', thStyle: 'width: 5%', sortable: true, label: 'No.' },
        { key: 'apply_date', thStyle: 'width: 10%', sortable: true, label: 'Date'},
        { key: 'partner', thStyle: 'width: 20%', sortable: false, label: 'Partner' },
        // { key: 'service', thStyle: 'width: 10%', sortable: false, label: 'Service' },
        { key: 'price', thStyle: 'width: 10%', sortable: false, label: 'Price' },
        { key: 'status', thStyle: 'width: 15%', sortable: false, label: 'Status' },
        { key: 'func', sortable: false, label: 'More' },
      ]
      return f;
    },
  },
  methods: {
    bill(invoice_id) {
      let url = "https://www.sandbox.paypal.com/invoice/s/pay/"
      if(location.hostname != 'localhost' && location.hostname != '10.20.0.4') { url = url.replace('sandbox', '') }
      console.log("result", url + invoice_id)
      window.open(`${url}${invoice_id}`);
    },
    remove_service(x) {
      console.log(x)
      this.service_list.splice(x, 1)
      // this.service_list = this.service_list.length ?  : []
    },
    set_service:function(x) {
      if(!this.service || !this.service.service_name) { return this.$toastr.e("required service") }
      let service = JSON.parse(JSON.stringify(this.service))
      this.service_list.push(service)

      this.invoice.amount += Number(service.amount)

      this.service.usage = 0
      this.service.amount = 0
      this.service.partner_price = 0
    },
    load_partner_service() {
      try{
       let partner_service_info = {
          target : 'partner.license', cmd : 'list',
          body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'is_del', value : false, op : '=' }, { name : 'is_alive', value : true, op : '=' }, { name : 'partner_id', value : this.invoice.partner_id, op : '=' }] }
        }

        Api.Manager(partner_service_info).then(rs => {
          if(rs.error) { return this.$toastr.e("load failed of license", this.$route.name) }

          rs.body.forEach(x => {
            if(!x.is_publish) {
              return console.log('not puglished', x.service_name)
            }
            this.partner_service.push({ id : x.id, customer_price : x.customer_price, partner_price : x.partner_price, service_name : x.service_name })

          })

        }).catch(e => this.$toastr.e(e.data.message, e.status, e.statusText))
      } catch(e) { console.log(e); this.$toastr.e(e.data.message, e.status, e.statusText); }
    },
    new_invoice() {
      if(!this.invoice.month && (!this.invoice.start_at || !this.invoice.end_at)) { return this.$toastr.w("plz, select date")  }
      else if(moment(this.invoice.month).add(-1, 'month').diff(moment(), 'month') >= 0) {
        return this.$toastr.w("Future cannot issue invoice")
      }

      console.log(this.invoice.month ? this.invoice.month.format("yyyy-MM-DD") : '')
      this.invoice.month = this.invoice.month ? this.invoice.month.format("yyyy-MM-DD") : ''
      this.invoice.start_at = this.invoice.start_at ? moment(this.invoice.start_at).format("yyyy-MM-DD") : ''
      this.invoice.end_at = this.invoice.end_at ? moment(this.invoice.end_at).format("yyyy-MM-DD") : ''

      Api.Manager({ target : 'invoice.partner', cmd : 'create', body : Object.assign({}, this.invoice, { service_list : this.service_list })})
        .then(rs => {
          console.log("result", rs.body)
          window.open(rs.body);
        })
        .catch(e => {
          console.log(e)
          this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
        });
    },
    change_failed($event) { if($event == true || $event == false) { this.so.opt['is_failed'] = $event; this.refresh(); } },
    change_done($event) { if($event == true || $event == false) { this.so.opt['is_paid'] = $event; this.refresh(); } },
    change_refunded($event) { if($event == true || $event == false) { this.so.opt['is_refunded'] = $event; this.refresh(); } },
    modal_history(history) {
      this.payment_history = history.map(r => typeof r == typeof 'string' ? JSON.parse(r) : r)
      this.confirm_payment_history = true;

      console.log("payment history load", history.length)
    },
    setPartner(item) {
      console.log("partner info", item.username, item.id)
      this.invoice.partner_username = this.so.opt['partner_username'] = item.username
      this.invoice.partner_id = this.so.opt['partner_id'] = item.id
      this.partner_name = item.username;
      this.chainPartner = false;
      this.load_partner_service()
      this.refresh()
    },
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        // this.so.opt['paid_at_ed'] = moment().add(1, "day").startOf('d');
        // this.so.opt['refund_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if((k.length > 3 && k.substring(k.length - 3) == "_id") || [].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true' || (k.length > 2 && k.substring(0, 2) == "is")) {
        return { name : k, value : v == false ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.th) { clearTimeout(this.th); this.th = undefined; }
      if(!this.th && this.sync.stop) { this.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.group_name = ''; this.partner_name = ''; this.refresh(); },
    refresh() { if(!this.loading) { this.$refs._list.refresh(); } },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      this.loading = true;
      let so = {
        target : 'invoice.partner', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && this.so.sv) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      if(this.partner_id) { so.body.and.push({ name : 'partner_id', value : this.partner_id, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'paid_at_sd':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 7), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 7), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" } }
              break;
            case 'paid_at_ed':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 7), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 7), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" } }
              break;
            case 'refund_at_sd':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 9), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 9), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" } }
              break;
            case 'refund_at_ed':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 9), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 9), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" } }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Manager(so).then(rs => {
        if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
        this.loading = false; this.so.totalRows = rs.total; return rs.body;
      }).catch(e => {
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
      });
    },
    summary() {
      Api.Manager({ target : 'invoice.partner', cmd : 'summary', body : { partner_id : this.partner_id ? this.partner_id : 0 } })
        .then(rs => { this.model = Object.assign(this.model, { total_paid : rs.body.total_paid, not_paid : rs.body.not_paid }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {
      if(this.view_detail === false) { this.$emit("select", item); }
      else { this.$router.push({ name : 'InvoicePartner', params : { id : item.id } }); }
    },
  },
  created() { console.log('invoice.partner.List.vue', 'created'); },
  destroyed() { console.log('invoice.partner.List.vue', 'destroyed'); },
  mounted() {
    console.log('invoice.partner.List.vue', 'mounted');
  },
}
</script>
